import React, { useEffect } from 'react';
import { FileWithPath, useDropzone } from 'react-dropzone';

import { PictureFilled } from '@ant-design/icons';

import { DropZoneContainer, Icon, SubText, Text } from './styles';

interface DropZoneProps {
  onDrop: (acceptedFiles: FileWithPath[]) => void;
  onEditClick?: (open: () => void) => void;
  hidden?: boolean;
  allowedFiles?: { [key: string]: string[] };
}

const DropZone: React.FC<DropZoneProps> = ({
  onDrop,
  onEditClick,
  hidden = false,
  allowedFiles = {},
}) => {
  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop,
    noClick: !!onEditClick,
    accept: allowedFiles,
  });

  useEffect(() => {
    if (onEditClick) {
      onEditClick(open);
    }
  }, [onEditClick, open]);

  return (
    <DropZoneContainer
      {...getRootProps()}
      style={{ display: hidden ? 'none' : 'flex' }}
    >
      <input {...getInputProps()} />
      <Icon>
        <PictureFilled />
      </Icon>
      <Text>Add Photo / Video</Text>
      <SubText>or Drag and Drop</SubText>
    </DropZoneContainer>
  );
};

export default DropZone;
